import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100",
    style: { "z-index": "9999" }
};
const _hoisted_2 = {
    key: 1,
    class: "row"
};
const _hoisted_3 = { class: "col-lg-12 col-xl-12 col-xxl-4" };
const _hoisted_4 = { class: "card mb-25 border-0 rounded-0 bg-white order-details-box letter-spacing" };
const _hoisted_5 = {
    key: 0,
    class: "card-head bg-white d-flex align-items-center justify-content-between"
};
const _hoisted_6 = { class: "d-flex align-items-center" };
const _hoisted_7 = { class: "mb-0 fw-bold text-black" };
const _hoisted_8 = { class: "mb-0 fw-bold text-black ms-10 ms-md-15" };
const _hoisted_9 = {
    key: 0,
    class: "badge text-bg-success fs-13 ms-10",
    style: { "margin-left": "70px" }
};
const _hoisted_10 = {
    key: 1,
    class: "badge text-bg-warning fs-13",
    style: { "margin-left": "70px" }
};
const _hoisted_11 = {
    key: 1,
    class: "card-body"
};
const _hoisted_12 = { class: "list ps-0 mb-0 list-unstyled" };
const _hoisted_13 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_14 = { class: "title text-black fs-md-15 fs-lg-16 fw-semibold position-relative" };
const _hoisted_15 = { class: "d-block text-paragraph fs-md-15 fs-lg-16" };
const _hoisted_16 = {
    key: 0,
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_17 = { class: "title text-black fs-md-15 fs-lg-16 fw-semibold position-relative" };
const _hoisted_18 = { class: "d-block text-paragraph fs-md-15 fs-lg-16" };
const _hoisted_19 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_20 = { class: "title text-black fs-md-15 fs-lg-16 fw-semibold position-relative" };
const _hoisted_21 = {
    key: 0,
    class: "d-flex align-items-center text-paragraph fs-md-15 fs-lg-16"
};
const _hoisted_22 = {
    key: 1,
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_23 = { class: "title text-black fs-md-15 fs-lg-16 fw-semibold position-relative" };
const _hoisted_24 = { class: "d-block badge text-bg-info fs-13" };
const _hoisted_25 = {
    key: 0,
    class: "col-lg-6 col-xl-12 col-xxl-4"
};
const _hoisted_26 = { class: "card mb-25 border-0 rounded-0 bg-white order-details-box letter-spacing" };
const _hoisted_27 = { class: "card-head bg-white d-flex align-items-center" };
const _hoisted_28 = { class: "mb-0 fw-bold text-black ms-10 ms-md-15" };
const _hoisted_29 = { class: "card-body" };
const _hoisted_30 = { class: "list ps-0 mb-0 list-unstyled" };
const _hoisted_31 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_32 = { class: "title text-black fs-md-15 fs-lg-16 fw-semibold position-relative" };
const _hoisted_33 = { class: "d-block text-paragraph fs-md-15 fs-lg-16" };
const _hoisted_34 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_35 = { class: "title text-black fs-md-15 fs-lg-16 fw-semibold position-relative" };
const _hoisted_36 = { class: "d-block text-white badge text-bg-danger fs-md-15 fs-lg-16" };
const _hoisted_37 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_38 = { class: "title text-black fs-md-15 fs-lg-16 fw-semibold position-relative" };
const _hoisted_39 = { class: "d-block text-paragraph fs-md-15 fs-lg-16" };
const _hoisted_40 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_41 = { class: "title text-black fs-md-15 fs-lg-16 fw-semibold position-relative" };
const _hoisted_42 = {
    key: 0,
    class: "d-block text-paragraph fs-md-15 fs-lg-16"
};
const _hoisted_43 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_44 = { class: "title text-black fs-md-15 fs-lg-16 fw-semibold position-relative" };
const _hoisted_45 = { class: "d-block text-paragraph fs-md-15 fs-lg-16" };
const _hoisted_46 = {
    key: 1,
    class: "col-lg-6 col-xl-12 col-xxl-4"
};
const _hoisted_47 = { class: "card mb-25 border-0 rounded-0 bg-white order-details-box letter-spacing" };
const _hoisted_48 = { class: "card-head bg-white d-flex align-items-center" };
const _hoisted_49 = { class: "mb-0 fw-bold text-black ms-10 ms-md-15" };
const _hoisted_50 = { class: "card-body" };
const _hoisted_51 = { class: "list ps-0 mb-0 list-unstyled" };
const _hoisted_52 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_53 = { class: "title text-black fs-md-15 fs-lg-16 fw-semibold position-relative" };
const _hoisted_54 = { class: "d-flex align-items-center justify-content-between mt-3" };
const _hoisted_55 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_56 = { class: "title text-black fs-md-15 fs-lg-16 fw-semibold position-relative" };
const _hoisted_57 = {
    key: 0,
    class: "d-block text-paragraph fs-md-15 fs-lg-16"
};
const _hoisted_58 = {
    key: 1,
    class: "d-block text-paragraph fs-md-15 fs-lg-16"
};
const _hoisted_59 = {
    key: 2,
    class: "col-lg-8"
};
const _hoisted_60 = { class: "card mb-25 border-0 rounded-0 bg-white order-details-box letter-spacing" };
const _hoisted_61 = { class: "card-head bg-white d-flex align-items-center" };
const _hoisted_62 = { class: "mb-0 fw-bold text-black ms-10 ms-md-15" };
const _hoisted_63 = { class: "card-body" };
const _hoisted_64 = { class: "table-responsive" };
const _hoisted_65 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_66 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 ps-0"
};
const _hoisted_67 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13"
};
const _hoisted_68 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13"
};
const _hoisted_69 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pe-0"
};
const _hoisted_70 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pe-0"
};
const _hoisted_71 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pe-0"
};
const _hoisted_72 = { key: 0 };
const _hoisted_73 = {
    colspan: "8",
    class: "text-center py-4"
};
const _hoisted_74 = {
    colspan: "6",
    class: "text-center fw-bold text-primary py-2"
};
const _hoisted_75 = { class: "shadow-none fw-medium text-black product-title ps-0" };
const _hoisted_76 = { class: "d-flex align-items-center text-decoration-none text-black fs-md-15 fs-lg-16" };
const _hoisted_77 = ["src"];
const _hoisted_78 = { class: "shadow-none lh-1 fw-medium text-paragraph" };
const _hoisted_79 = { class: "shadow-none lh-1 fw-medium text-paragraph" };
const _hoisted_80 = { class: "shadow-none lh-1 fw-medium text-paragraph" };
const _hoisted_81 = ["onClick"];
const _hoisted_82 = {
    key: 1,
    class: "text-primary fw-medium text-decoration-underline"
};
const _hoisted_83 = { class: "shadow-none lh-1 fw-medium text-paragraph" };
const _hoisted_84 = ["onClick"];
const _hoisted_85 = {
    key: 1,
    class: "text-primary fw-medium text-decoration-underline"
};
const _hoisted_86 = { class: "shadow-none lh-1 fw-medium text-paragraph pe-0" };
const _hoisted_87 = { key: 0 };
const _hoisted_88 = { class: "card mb-25 border-0 rounded-0 bg-white order-details-box letter-spacing" };
const _hoisted_89 = { class: "card-head bg-white d-flex justify-content-between align-items-center" };
const _hoisted_90 = { class: "mb-0 fw-bold text-black" };
const _hoisted_91 = {
    key: 0,
    class: "dropdown"
};
const _hoisted_92 = { class: "dropdown-menu" };
const _hoisted_93 = ["onClick"];
const _hoisted_94 = { class: "card-body" };
const _hoisted_95 = { class: "order-summary-list ps-0 mb-0 list-unstyled" };
const _hoisted_96 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_97 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_98 = {
    key: 0,
    class: "dropdown"
};
const _hoisted_99 = { class: "dropdown-menu" };
const _hoisted_100 = ["onClick"];
const _hoisted_101 = { key: 1 };
const _hoisted_102 = { class: "card mb-25 border-0 rounded-0 bg-white order-details-box letter-spacing" };
const _hoisted_103 = { class: "card-head bg-white d-flex justify-content-between align-items-center" };
const _hoisted_104 = { class: "mb-0 fw-bold text-black" };
const _hoisted_105 = {
    key: 0,
    class: "dropdown"
};
const _hoisted_106 = { class: "dropdown-menu" };
const _hoisted_107 = ["onClick"];
const _hoisted_108 = { class: "col-lg-4" };
const _hoisted_109 = {
    key: 0,
    class: "card mb-25 border-0 rounded-0 bg-white order-details-box letter-spacing"
};
const _hoisted_110 = { class: "card-head bg-white d-flex align-items-center" };
const _hoisted_111 = { class: "mb-0 fw-bold text-black ms-10 ms-md-15" };
const _hoisted_112 = { class: "card-body" };
const _hoisted_113 = { class: "order-summary-list ps-0 mb-0 list-unstyled" };
const _hoisted_114 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_115 = { class: "d-block text-muted text-uppercase fw-medium fs-13" };
const _hoisted_116 = { class: "d-block text-muted text-uppercase fw-medium fs-13" };
const _hoisted_117 = { class: "d-flex align-items-center justify-content-between pt-2 fw-bold text-primary" };
const _hoisted_118 = { class: "d-flex justify-content-between w-100" };
const _hoisted_119 = { class: "pl-4" };
const _hoisted_120 = ["src"];
const _hoisted_121 = {
    key: 0,
    class: "d-block text-black fw-bolder fw-medium"
};
const _hoisted_122 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_123 = { class: "d-block text-black fw-bolder fw-medium" };
const _hoisted_124 = { class: "d-block text-black fw-bolder fw-medium" };
const _hoisted_125 = {
    key: 0,
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_126 = { class: "d-block text-primary fw-bolder fw-medium" };
const _hoisted_127 = { class: "d-block text-primary fw-bolder fw-medium" };
const _hoisted_128 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_129 = { class: "d-block text-black fw-bolder fw-medium" };
const _hoisted_130 = { class: "d-block text-black fw-bolder fw-medium" };
const _hoisted_131 = {
    key: 1,
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_132 = { class: "d-block text-primary fw-bolder fw-medium" };
const _hoisted_133 = { class: "d-block text-primary fw-bolder fw-medium" };
const _hoisted_134 = {
    key: 2,
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_135 = { class: "d-block text-primary fw-bolder fw-medium" };
const _hoisted_136 = { class: "d-block text-primary fw-bolder fw-medium" };
const _hoisted_137 = {
    key: 3,
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_138 = { class: "d-block text-primary fw-bolder fw-medium" };
const _hoisted_139 = { class: "d-block text-primary fw-bolder fw-medium" };
const _hoisted_140 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_141 = { class: "d-block text-primary fw-bolder fw-medium" };
const _hoisted_142 = { class: "d-block text-primary fw-bolder fw-medium" };
const _hoisted_143 = {
    key: 3,
    class: "col-lg-4"
};
const _hoisted_144 = { class: "card mb-25 border-0 rounded-0 bg-white order-details-box letter-spacing" };
const _hoisted_145 = { class: "card-head bg-white d-flex justify-content-between align-items-center" };
const _hoisted_146 = { class: "mb-0 fw-bold text-black" };
const _hoisted_147 = { class: "card-body" };
const _hoisted_148 = { class: "order-summary-list ps-0 mb-0 list-unstyled" };
const _hoisted_149 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_150 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_151 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_152 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_153 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_154 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_155 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_156 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_157 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_158 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_159 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_160 = {
    key: 0,
    class: "d-block text-paragraph fw-medium"
};
const _hoisted_161 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_162 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_163 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_164 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_165 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_166 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_167 = {
    key: 4,
    class: "col-lg-4"
};
const _hoisted_168 = { class: "card mb-25 border-0 rounded-0 bg-white order-details-box letter-spacing" };
const _hoisted_169 = { class: "card-head bg-white d-flex justify-content-between align-items-center" };
const _hoisted_170 = { class: "mb-0 fw-bold text-black" };
const _hoisted_171 = { class: "card-body" };
const _hoisted_172 = { class: "order-summary-list ps-0 mb-0 list-unstyled" };
const _hoisted_173 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_174 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_175 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_176 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_177 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_178 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_179 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_180 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_181 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_182 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_183 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_184 = {
    key: 0,
    class: "d-block text-paragraph fw-medium"
};
const _hoisted_185 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_186 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_187 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_188 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_189 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_190 = { class: "d-block text-paragraph fw-medium" };
const _hoisted_191 = {
    class: "modal fade",
    id: "contentModalScrollable_ingredient",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_192 = { class: "modal-dialog modal-dialog-scrollable modal-lg" };
const _hoisted_193 = { class: "modal-content flex-column justify-content-center" };
const _hoisted_194 = { class: "modal-body flex-row align-items-center justify-content-center" };
const _hoisted_195 = { class: "table-responsive" };
const _hoisted_196 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_197 = { class: "bg-success text-white" };
const _hoisted_198 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
};
const _hoisted_199 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_200 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_201 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_202 = { key: 0 };
const _hoisted_203 = { class: "shadow-none lh-1 fw-bold ps-0" };
const _hoisted_204 = { class: "shadow-none lh-1 fw-medium" };
const _hoisted_205 = {
    key: 0,
    class: "badge text-outline-primary"
};
const _hoisted_206 = {
    key: 1,
    class: "badge text-outline-danger"
};
const _hoisted_207 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_208 = { class: "d-flex align-items-center" };
const _hoisted_209 = { class: "shadow-none lh-1 fw-medium text-body-tertiary" };
const _hoisted_210 = {
    class: "modal fade",
    id: "contentModalScrollable_supplement",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_211 = { class: "modal-dialog modal-dialog-scrollable modal-lg" };
const _hoisted_212 = { class: "modal-content flex-column justify-content-center" };
const _hoisted_213 = { class: "modal-header" };
const _hoisted_214 = { class: "modal-title fs-5" };
const _hoisted_215 = { class: "modal-body" };
const _hoisted_216 = { class: "table-responsive" };
const _hoisted_217 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_218 = { class: "bg-info text-white" };
const _hoisted_219 = { class: "fs-13 ps-0" };
const _hoisted_220 = { class: "fs-13" };
const _hoisted_221 = { class: "fs-13" };
const _hoisted_222 = { class: "fs-13" };
const _hoisted_223 = { key: 0 };
const _hoisted_224 = { class: "fw-bold ps-0" };
const _hoisted_225 = { class: "fw-semibold text-primary" };
const _hoisted_226 = { key: 1 };
const _hoisted_227 = {
    colspan: "4",
    class: "text-center text-muted"
};
const _hoisted_228 = {
    class: "modal fade",
    id: "contentModalScrollable_facture",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_229 = { class: "modal-dialog modal-dialog-scrollable modal-lg" };
const _hoisted_230 = {
    key: 0,
    class: "modal-content"
};
const _hoisted_231 = { class: "modal-header" };
const _hoisted_232 = { class: "modal-title fs-5" };
const _hoisted_233 = { class: "modal-body flex-row align-items-center justify-content-center" };
const _hoisted_234 = {
    key: 0,
    class: "w-100 h-100"
};
const _hoisted_235 = ["src"];
const _hoisted_236 = {
    key: 1,
    class: "flex-column items-center justify-content-center"
};
const _hoisted_237 = { class: "modal-footer" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_LoaderComponent)
            ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        (_ctx.orderResponse)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.orderResponse.transactionReference), 1)
                                ]),
                                _createElementVNode("h5", _hoisted_8, [
                                    (_ctx.orderResponse.DeliveryPreference === 'immediat')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t('order.immediately')), 1))
                                        : _createCommentVNode("", true),
                                    (_ctx.orderResponse.DeliveryPreference === 'ulterieur')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.$t('order.preOrder')), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.orderResponse)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createElementVNode("ul", _hoisted_12, [
                                    _createElementVNode("li", _hoisted_13, [
                                        _createElementVNode("div", _hoisted_14, [
                                            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "flaticon-calendar" }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('order.createDate')), 1)
                                        ]),
                                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatDate(_ctx.orderResponse.created_at, "dd/MM/yyyy - HH:mm")), 1)
                                    ]),
                                    (_ctx.orderResponse.DeliveryPreference !== 'immediat' &&
                                        _ctx.orderResponse.timeOrder)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                                            _createElementVNode("div", _hoisted_17, [
                                                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "flaticon-time" }, null, -1)),
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('order.pickupDate')), 1)
                                            ]),
                                            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.orderResponse.timeOrder &&
                                                _ctx.isValidDate(_ctx.orderResponse.timeOrder)
                                                ? _ctx.formatDate(_ctx.orderResponse.timeOrder, "dd/MM/yyyy - HH:mm")
                                                : (typeof _ctx.orderResponse.timeOrder === 'string' && _ctx.orderResponse.timeOrder.trim().length > 0
                                                    ? _ctx.orderResponse.timeOrder
                                                    : _ctx.$t('order.notSpecified'))), 1)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("li", _hoisted_19, [
                                        _createElementVNode("div", _hoisted_20, [
                                            _cache[6] || (_cache[6] = _createElementVNode("i", { class: "flaticon-atm" }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('order.paymentMethod')), 1)
                                        ]),
                                        (_ctx.orderResponse.payment?.method)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.translatePaymentMethod(_ctx.orderResponse.payment?.method)), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    (_ctx.orderResponse?.order_type)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                                            _createElementVNode("div", _hoisted_23, [
                                                _cache[7] || (_cache[7] = _createElementVNode("i", { class: "flaticon-express-delivery" }, null, -1)),
                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('order.orderType')), 1)
                                            ]),
                                            _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.translateOrderType(_ctx.orderResponse.order_type)), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                (_ctx.orderResponse)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                                _cache[8] || (_cache[8] = _createElementVNode("i", { class: "flaticon-user-3 text-success" }, null, -1)),
                                _createElementVNode("h5", _hoisted_28, _toDisplayString(_ctx.$t('order.customerInfo')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("ul", _hoisted_30, [
                                    _createElementVNode("li", _hoisted_31, [
                                        _createElementVNode("div", _hoisted_32, [
                                            _cache[9] || (_cache[9] = _createElementVNode("i", { class: "flaticon-user-1" }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('order.civility')), 1)
                                        ]),
                                        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.orderResponse?.customer?.civilite ?? '__'), 1)
                                    ]),
                                    _createElementVNode("li", _hoisted_34, [
                                        _createElementVNode("div", _hoisted_35, [
                                            _cache[10] || (_cache[10] = _createElementVNode("i", { class: "flaticon-user-1" }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('order.customerType')), 1)
                                        ]),
                                        _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.orderResponse.typeCustomer === "customer"
                                            ? _ctx.$t('order.company')
                                            : _ctx.$t('order.classic')), 1)
                                    ]),
                                    _createElementVNode("li", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, [
                                            _cache[11] || (_cache[11] = _createElementVNode("i", { class: "flaticon-user-1" }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('order.fullName')), 1)
                                        ]),
                                        _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.orderResponse.civilite || "") + " " + _toDisplayString(_ctx.orderResponse.customer?.first_name ||
                                            _ctx.orderResponse.guest_first_name ||
                                            "") + " " + _toDisplayString(_ctx.orderResponse.customer?.last_name ||
                                            _ctx.orderResponse.guest_last_name ||
                                            ""), 1)
                                    ]),
                                    _createElementVNode("li", _hoisted_40, [
                                        _createElementVNode("div", _hoisted_41, [
                                            _cache[12] || (_cache[12] = _createElementVNode("i", { class: "flaticon-envelope" }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('order.email')), 1)
                                        ]),
                                        (!_ctx.orderResponse?.customer?.email?.includes('guest_') &&
                                            !_ctx.orderResponse?.guest_email?.includes('guest_'))
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.orderResponse.customer?.email || _ctx.orderResponse.guest_email), 1))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("li", _hoisted_43, [
                                        _createElementVNode("div", _hoisted_44, [
                                            _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-phone-call" }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('order.phoneNumber')), 1)
                                        ]),
                                        _createElementVNode("span", _hoisted_45, _toDisplayString((() => {
                                            const phone = _ctx.orderResponse.customer?.phone || _ctx.orderResponse.guest_phone_number;
                                            if (!phone)
                                                return "-";
                                            if (phone.startsWith('+'))
                                                return phone;
                                            return '+' + phone;
                                        })()), 1)
                                    ])
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.orderResponse)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                            _createElementVNode("div", _hoisted_48, [
                                _cache[14] || (_cache[14] = _createElementVNode("i", { class: "flaticon-document text-info" }, null, -1)),
                                _createElementVNode("h5", _hoisted_49, _toDisplayString(_ctx.$t('order.invoice')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_50, [
                                _createElementVNode("ul", _hoisted_51, [
                                    _createElementVNode("li", _hoisted_52, [
                                        _createElementVNode("div", _hoisted_53, [
                                            _cache[15] || (_cache[15] = _createElementVNode("i", { class: "flaticon-copy" }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('order.invoiceNumber')), 1)
                                        ]),
                                        _createElementVNode("span", {
                                            onClick: _cache[0] || (_cache[0] =
                                                //@ts-ignore
                                                (...args) => (_ctx.displayInvoire && _ctx.displayInvoire(...args))),
                                            class: "d-block text-primary fs-md-15 fs-lg-16 cursor-pointer text-decoration-underline",
                                            "data-bs-toggle": "modal",
                                            "data-bs-target": "#contentModalScrollable_facture"
                                        }, _toDisplayString(_ctx.orderResponse.transactionReference), 1)
                                    ]),
                                    _createElementVNode("li", _hoisted_54, [
                                        _createElementVNode("button", {
                                            class: "btn btn-outline-primary w-100",
                                            onClick: _cache[1] || (_cache[1] =
                                                //@ts-ignore
                                                (...args) => (_ctx.regeneratePdf && _ctx.regeneratePdf(...args))),
                                            id: "step-order-regenerate-pdf"
                                        }, [...(_cache[16] || (_cache[16] = [
                                                _createElementVNode("i", { class: "flaticon-printer me-2" }, null, -1),
                                                _createTextVNode(" Régénérer PDF ", -1)
                                            ]))])
                                    ]),
                                    _createElementVNode("li", _hoisted_55, [
                                        _createElementVNode("div", _hoisted_56, [
                                            _cache[17] || (_cache[17] = _createElementVNode("i", { class: "flaticon-bookmark" }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('order.coupon')), 1)
                                        ]),
                                        (_ctx.orderResponse.coupon_code)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(_ctx.orderResponse.coupon_code), 1))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_58, "-"))
                                    ])
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.orderResponse)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                        _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                                _cache[18] || (_cache[18] = _createElementVNode("i", { class: "flaticon-sterile-box text-primary" }, null, -1)),
                                _createElementVNode("h5", _hoisted_62, _toDisplayString(_ctx.$t('order.productList')) + " (ID #" + _toDisplayString(_ctx.getShortUuid(_ctx.orderResponse.id)) + ") ", 1)
                            ]),
                            _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("div", _hoisted_64, [
                                    _createElementVNode("table", _hoisted_65, [
                                        _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", _hoisted_66, _toDisplayString(_ctx.$t('order.productName')), 1),
                                                _createElementVNode("th", _hoisted_67, _toDisplayString(_ctx.$t('order.quantity')), 1),
                                                _createElementVNode("th", _hoisted_68, _toDisplayString(_ctx.$t('order.productPrice')), 1),
                                                _cache[19] || (_cache[19] = _createElementVNode("th", {
                                                    scope: "col",
                                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pe-0"
                                                }, null, -1)),
                                                _createElementVNode("th", _hoisted_69, _toDisplayString(_ctx.$t('order.ingredients')), 1),
                                                _createElementVNode("th", _hoisted_70, _toDisplayString(_ctx.$t('order.supplements')), 1),
                                                _createElementVNode("th", _hoisted_71, _toDisplayString(_ctx.$t('order.total')), 1)
                                            ])
                                        ]),
                                        _createElementVNode("tbody", null, [
                                            (_ctx.isLoading)
                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_72, [
                                                    _createElementVNode("td", _hoisted_73, [
                                                        _createVNode(_component_LoaderComponent)
                                                    ])
                                                ]))
                                                : (!_ctx.isLoading && _ctx.orderItemsWithNewStructure.length > 0)
                                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.orderItemsWithNewStructure, (categoryItem, categoryIndex) => {
                                                        return (_openBlock(), _createElementBlock(_Fragment, { key: categoryIndex }, [
                                                            _createElementVNode("tr", null, [
                                                                _createElementVNode("td", _hoisted_74, _toDisplayString(categoryItem?.category || _ctx.$t('order.noCategory')), 1)
                                                            ]),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryItem?.products || [], (product, productIndex) => {
                                                                return (_openBlock(), _createElementBlock("tr", {
                                                                    key: `${categoryIndex}-${productIndex}`
                                                                }, [
                                                                    _createElementVNode("th", _hoisted_75, [
                                                                        _createElementVNode("span", _hoisted_76, [
                                                                            _createElementVNode("img", {
                                                                                src: product?.product_image,
                                                                                class: "me-15",
                                                                                width: "44",
                                                                                alt: "product"
                                                                            }, null, 8, _hoisted_77),
                                                                            _createTextVNode(" " + _toDisplayString(product?.name || _ctx.$t('order.unknownProduct')), 1)
                                                                        ])
                                                                    ]),
                                                                    _createElementVNode("td", _hoisted_78, " x" + _toDisplayString(product?.quantity || 0), 1),
                                                                    _createElementVNode("td", _hoisted_79, _toDisplayString(product?.price || 0) + " CHF ", 1),
                                                                    _cache[20] || (_cache[20] = _createElementVNode("td", { class: "shadow-none lh-1 fw-medium text-paragraph pe-0" }, null, -1)),
                                                                    _createElementVNode("td", _hoisted_80, [
                                                                        (product?.ingredient?.length > 0)
                                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                                key: 0,
                                                                                onClick: ($event) => (_ctx.selectedOrderItem(product)),
                                                                                class: "text-primary fw-medium text-decoration-underline btn btn-link",
                                                                                type: "button",
                                                                                "data-bs-toggle": "modal",
                                                                                "data-bs-target": "#contentModalScrollable_ingredient"
                                                                            }, " (" + _toDisplayString(product?.ingredient?.length || 0) + ") " + _toDisplayString(_ctx.$t('order.ingredients')), 9, _hoisted_81))
                                                                            : (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(_ctx.$t('order.noIngredients')), 1))
                                                                    ]),
                                                                    _createElementVNode("td", _hoisted_83, [
                                                                        (product?.supplement?.length > 0)
                                                                            ? (_openBlock(), _createElementBlock("button", {
                                                                                key: 0,
                                                                                onClick: ($event) => (_ctx.selectedOrderSupplement(product)),
                                                                                class: "text-primary fw-medium text-decoration-underline btn btn-link",
                                                                                type: "button",
                                                                                "data-bs-toggle": "modal",
                                                                                "data-bs-target": "#contentModalScrollable_supplement"
                                                                            }, " (" + _toDisplayString(product?.supplement?.length || 0) + ") " + _toDisplayString(_ctx.$t('order.supplements')), 9, _hoisted_84))
                                                                            : (_openBlock(), _createElementBlock("span", _hoisted_85, _toDisplayString(_ctx.$t('order.noSupplements')), 1))
                                                                    ]),
                                                                    _createElementVNode("td", _hoisted_86, _toDisplayString((product?.price || 0)) + " CHF ", 1)
                                                                ]));
                                                            }), 128))
                                                        ], 64));
                                                    }), 128))
                                                    : _createCommentVNode("", true)
                                        ])
                                    ])
                                ])
                            ])
                        ]),
                        (_ctx.orderResponse)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                                _createElementVNode("div", _hoisted_88, [
                                    _createElementVNode("div", _hoisted_89, [
                                        _createElementVNode("h5", _hoisted_90, _toDisplayString(_ctx.$t('order.orderStatus')), 1),
                                        (_ctx.allOrderStatus.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                                                _createElementVNode("button", {
                                                    class: _normalizeClass(["btn btn-sm dropdown-toggle", _ctx.orderStatusBtnClass(_ctx.orderResponse.status)]),
                                                    type: "button",
                                                    "data-bs-toggle": "dropdown",
                                                    "aria-expanded": "false"
                                                }, _toDisplayString(_ctx.fetchStatusOrderFr(_ctx.orderResponse.status)), 3),
                                                _createElementVNode("ul", _hoisted_92, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allOrderStatus, (status) => {
                                                        return (_openBlock(), _createElementBlock("li", { key: status }, [
                                                            _createElementVNode("a", {
                                                                onClick: ($event) => (_ctx.updateStatusOrder(status, _ctx.methodePaiementSelected[0]?.type ?? '')),
                                                                class: "dropdown-item",
                                                                href: "#"
                                                            }, _toDisplayString(_ctx.fetchStatusOrderFr(status)), 9, _hoisted_93)
                                                        ]));
                                                    }), 128))
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", _hoisted_94, [
                                        _createElementVNode("ul", _hoisted_95, [
                                            _createElementVNode("li", _hoisted_96, [
                                                _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.$t('order.paymentStatus')), 1),
                                                (_ctx.allPaiementOrderStatus.length > 0 && _ctx.orderResponse.payment)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                                        _createElementVNode("button", {
                                                            class: _normalizeClass(["btn btn-sm dropdown-toggle", {
                                                                    'btn-outline-danger': _ctx.orderResponse.payment?.status === 'pending' ||
                                                                        _ctx.orderResponse.payment?.status === 'failed',
                                                                    'btn-outline-primary': _ctx.orderResponse.payment?.status === 'paid' ||
                                                                        _ctx.orderResponse.payment?.status === 'completed',
                                                                    'btn-outline-secondary': _ctx.orderResponse.payment?.status === 'refunded',
                                                                    'btn-outline-info': _ctx.orderResponse.payment?.status === 'processing',
                                                                    'btn-outline-warning': _ctx.orderResponse.payment?.status === 'cancelled',
                                                                }]),
                                                            type: "button",
                                                            "data-bs-toggle": "dropdown",
                                                            "aria-expanded": "false"
                                                        }, _toDisplayString(_ctx.fetchStatusOrderPaiementFr(_ctx.orderResponse.payment?.status)), 3),
                                                        _createElementVNode("ul", _hoisted_99, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allPaiementOrderStatus, (status) => {
                                                                return (_openBlock(), _createElementBlock("li", { key: status }, [
                                                                    _createElementVNode("a", {
                                                                        onClick: ($event) => (_ctx.updatePaymentStatus(status)),
                                                                        class: "dropdown-item",
                                                                        href: "#"
                                                                    }, _toDisplayString(_ctx.fetchStatusOrderPaiementFr(status)), 9, _hoisted_100)
                                                                ]));
                                                            }), 128))
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ])
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.orderResponse)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                _createElementVNode("div", _hoisted_102, [
                                    _createElementVNode("div", _hoisted_103, [
                                        _createElementVNode("h5", _hoisted_104, _toDisplayString(_ctx.$t('order.paymentMethodTitle')), 1),
                                        (_ctx.allPaymentMethods.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                                _createElementVNode("button", {
                                                    class: _normalizeClass(["btn btn-sm dropdown-toggle",
                                                        _ctx.backgroundColorPaymentMethod(_ctx.orderResponse.payment?.method)
                                                    ]),
                                                    type: "button",
                                                    "data-bs-toggle": "dropdown",
                                                    "aria-expanded": "false"
                                                }, _toDisplayString(_ctx.translatePaymentMethod(_ctx.orderResponse.payment?.method)), 3),
                                                _createElementVNode("ul", _hoisted_106, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allPaymentMethods, (method) => {
                                                        return (_openBlock(), _createElementBlock("li", { key: method }, [
                                                            _createElementVNode("a", {
                                                                onClick: ($event) => (_ctx.updatePaymentMethod(method)),
                                                                class: "dropdown-item",
                                                                href: "#"
                                                            }, _toDisplayString(_ctx.translatePaymentMethod(method)), 9, _hoisted_107)
                                                        ]));
                                                    }), 128))
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_108, [
                    (_ctx.orderResponse)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                            _createElementVNode("div", _hoisted_110, [
                                _cache[21] || (_cache[21] = _createElementVNode("i", { class: "flaticon-document text-info" }, null, -1)),
                                _createElementVNode("h5", _hoisted_111, _toDisplayString(_ctx.$t('order.orderSummary')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_112, [
                                _createElementVNode("ul", _hoisted_113, [
                                    _createElementVNode("li", _hoisted_114, [
                                        _createElementVNode("span", _hoisted_115, _toDisplayString(_ctx.$t('order.description')), 1),
                                        _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.$t('order.price')), 1)
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderItemsWithNewStructure, (categoryItem, categoryIndex) => {
                                        return (_openBlock(), _createElementBlock(_Fragment, { key: categoryIndex }, [
                                            _createElementVNode("li", _hoisted_117, [
                                                _createElementVNode("span", null, _toDisplayString(categoryItem?.category || "---"), 1)
                                            ]),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryItem?.products || [], (product, productIndex) => {
                                                return (_openBlock(), _createElementBlock("li", {
                                                    key: `${categoryIndex}-${productIndex}`,
                                                    class: "d-flex justify-content-between pt-2 flex-column justify-self-start"
                                                }, [
                                                    _createElementVNode("div", _hoisted_118, [
                                                        _createElementVNode("span", _hoisted_119, [
                                                            _createElementVNode("img", {
                                                                src: product?.product_image,
                                                                class: "me-15",
                                                                width: "44",
                                                                alt: "product"
                                                            }, null, 8, _hoisted_120),
                                                            _createTextVNode(_toDisplayString(product?.quantity || 0) + "x " + _toDisplayString(product?.name || "---") + " " + _toDisplayString(product?.size?.name || product?.size), 1)
                                                        ]),
                                                        _createElementVNode("span", null, _toDisplayString((product?.price || 0).toFixed(2)) + " CHF", 1)
                                                    ]),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product?.optionSpecific || [], (optionSpecific, index) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            key: index,
                                                            class: "d-block fw-bolder fw-medium text-paragraph fs-sm-13 fs-md-14"
                                                        }, _toDisplayString(optionSpecific.name), 1));
                                                    }), 128)),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product?.ingredient || [], (ingredient, index) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            key: index,
                                                            class: "d-block text-paragraph fs-sm-13 fs-md-14"
                                                        }, " + " + _toDisplayString(ingredient.name) + " (" + _toDisplayString((Number(ingredient.extra_cost_price) || 0) * 1) + " CHF ) ", 1));
                                                    }), 128)),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product?.supplement || [], (supplement, index) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            key: index,
                                                            class: "d-block text-paragraph fs-sm-13 fs-md-14"
                                                        }, " + " + _toDisplayString(supplement.name) + " (" + _toDisplayString((Number(supplement.extra_cost_price) || 0) * 1) + " CHF ) ", 1));
                                                    }), 128)),
                                                    (product?.removedIngredients?.length > 0)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_121, _toDisplayString(_ctx.$t('order.removed')), 1))
                                                        : _createCommentVNode("", true),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product?.removedIngredients || [], (removedIngredient, index) => {
                                                        return (_openBlock(), _createElementBlock("div", {
                                                            key: index,
                                                            class: "d-block text-paragraph fs-sm-13 fs-md-14"
                                                        }, " - " + _toDisplayString(typeof removedIngredient === "object" ? removedIngredient.name : removedIngredient), 1));
                                                    }), 128))
                                                ]));
                                            }), 128))
                                        ], 64));
                                    }), 128)),
                                    _createElementVNode("li", _hoisted_122, [
                                        _createElementVNode("span", _hoisted_123, _toDisplayString(_ctx.$t('order.subtotal')), 1),
                                        _createElementVNode("span", _hoisted_124, _toDisplayString(_ctx.orderResponse?.subtotal) + " CHF ", 1)
                                    ]),
                                    (_ctx.orderResponse.coupon_value !== null)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_125, [
                                            _createElementVNode("span", _hoisted_126, _toDisplayString(_ctx.$t('order.discount')), 1),
                                            _createElementVNode("span", _hoisted_127, " -" + _toDisplayString(_ctx.orderResponse?.coupon_value || 0) + " CHF ", 1)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("li", _hoisted_128, [
                                        _createElementVNode("span", _hoisted_129, _toDisplayString(_ctx.$t('order.includingVatDynamic', { rate: (_ctx.orderResponse?.tva_rate !== undefined && _ctx.orderResponse.tva_rate !== null ? parseFloat(_ctx.orderResponse.tva_rate) : 2.6).toFixed(2) })), 1),
                                        _createElementVNode("span", _hoisted_130, _toDisplayString((parseFloat(_ctx.orderResponse.tva || 0).toFixed(2))) + " CHF ", 1)
                                    ]),
                                    (Number(_ctx.orderResponse.additional_fee || 0) !== 0)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_131, [
                                            _createElementVNode("span", _hoisted_132, _toDisplayString(_ctx.$t('order.additionalFees')), 1),
                                            _createElementVNode("span", _hoisted_133, _toDisplayString(_ctx.orderResponse.additional_fee ?? "0") + " CHF ", 1)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (Number(_ctx.orderResponse.deliveryFee || 0) !== 0)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_134, [
                                            _createElementVNode("span", _hoisted_135, _toDisplayString(_ctx.$t('order.deliveryFee')), 1),
                                            _createElementVNode("span", _hoisted_136, _toDisplayString(_ctx.orderResponse.deliveryFee ?? "0") + " CHF ", 1)
                                        ]))
                                        : _createCommentVNode("", true),
                                    (Number(_ctx.orderResponse.divers || 0) !== 0)
                                        ? (_openBlock(), _createElementBlock("li", _hoisted_137, [
                                            _createElementVNode("span", _hoisted_138, _toDisplayString(_ctx.$t('pos.miscellaneousLabel')), 1),
                                            _createElementVNode("span", _hoisted_139, _toDisplayString(parseFloat(_ctx.orderResponse.divers || 0).toFixed(2)) + " CHF ", 1)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("li", _hoisted_140, [
                                        _createElementVNode("span", _hoisted_141, _toDisplayString(_ctx.$t('order.grandTotal')), 1),
                                        _createElementVNode("span", _hoisted_142, _toDisplayString(_ctx.orderResponse.total) + " CHF ", 1)
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                (_ctx.orderResponse && _ctx.orderResponse.order_type === 'delivery')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                        _createElementVNode("div", _hoisted_144, [
                            _createElementVNode("div", _hoisted_145, [
                                _createElementVNode("h5", _hoisted_146, _toDisplayString(_ctx.$t('order.paymentAddress')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_147, [
                                _createElementVNode("ul", _hoisted_148, [
                                    _createElementVNode("li", _hoisted_149, [
                                        _createElementVNode("span", _hoisted_150, _toDisplayString(_ctx.$t('order.postalCode')), 1),
                                        _createElementVNode("span", _hoisted_151, [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.orderResponse.billing?.postal_code || "-"), 1)
                                        ])
                                    ]),
                                    _createElementVNode("li", _hoisted_152, [
                                        _createElementVNode("span", _hoisted_153, _toDisplayString(_ctx.$t('order.locality')), 1),
                                        _createElementVNode("span", _hoisted_154, [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.orderResponse.billing?.city || "-"), 1)
                                        ])
                                    ]),
                                    _createElementVNode("li", _hoisted_155, [
                                        _createElementVNode("span", _hoisted_156, _toDisplayString(_ctx.$t('order.phone')), 1),
                                        _createElementVNode("span", _hoisted_157, [
                                            _createElementVNode("strong", null, _toDisplayString((() => {
                                                const phone = _ctx.orderResponse.billing?.phoneNumber;
                                                if (!phone)
                                                    return "-";
                                                if (phone.startsWith('+'))
                                                    return phone;
                                                return '+' + phone;
                                            })()), 1)
                                        ])
                                    ]),
                                    _createElementVNode("li", _hoisted_158, [
                                        _createElementVNode("span", _hoisted_159, _toDisplayString(_ctx.$t('order.email')), 1),
                                        (!_ctx.orderResponse?.guest_email?.includes('guest_'))
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_160, [
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.orderResponse.customer?.email ||
                                                    _ctx.orderResponse.guest_email ||
                                                    "-"), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("li", _hoisted_161, [
                                        _createElementVNode("span", _hoisted_162, _toDisplayString(_ctx.$t('order.street')), 1),
                                        _createElementVNode("span", _hoisted_163, [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.orderResponse.billing?.address || "-"), 1)
                                        ])
                                    ]),
                                    _createElementVNode("li", _hoisted_164, [
                                        _createElementVNode("span", _hoisted_165, _toDisplayString(_ctx.$t('order.number')), 1),
                                        _createElementVNode("span", _hoisted_166, [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.orderResponse.billing?.numeroRue ||
                                                _ctx.orderResponse.billing?.numero_rue ||
                                                "-"), 1)
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.orderResponse && _ctx.orderResponse.order_type === 'delivery')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                        _createElementVNode("div", _hoisted_168, [
                            _createElementVNode("div", _hoisted_169, [
                                _createElementVNode("h5", _hoisted_170, _toDisplayString(_ctx.$t('order.deliveryAddress')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_171, [
                                _createElementVNode("ul", _hoisted_172, [
                                    _createElementVNode("li", _hoisted_173, [
                                        _createElementVNode("span", _hoisted_174, _toDisplayString(_ctx.$t('order.postalCode')), 1),
                                        _createElementVNode("span", _hoisted_175, [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.orderResponse?.delivery?.postal_code || "-"), 1)
                                        ])
                                    ]),
                                    _createElementVNode("li", _hoisted_176, [
                                        _createElementVNode("span", _hoisted_177, _toDisplayString(_ctx.$t('order.locality')), 1),
                                        _createElementVNode("span", _hoisted_178, [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.orderResponse?.delivery?.locality || "-"), 1)
                                        ])
                                    ]),
                                    _createElementVNode("li", _hoisted_179, [
                                        _createElementVNode("span", _hoisted_180, _toDisplayString(_ctx.$t('order.phone')), 1),
                                        _createElementVNode("span", _hoisted_181, [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.orderResponse.customer?.phone ||
                                                _ctx.orderResponse.guest_phone_number ||
                                                "-"), 1)
                                        ])
                                    ]),
                                    _createElementVNode("li", _hoisted_182, [
                                        _createElementVNode("span", _hoisted_183, _toDisplayString(_ctx.$t('order.email')), 1),
                                        (!_ctx.orderResponse?.guest_email?.includes('guest_'))
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_184, [
                                                _createElementVNode("strong", null, _toDisplayString(_ctx.orderResponse.customer?.email ||
                                                    _ctx.orderResponse.guest_email ||
                                                    "-"), 1)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("li", _hoisted_185, [
                                        _createElementVNode("span", _hoisted_186, _toDisplayString(_ctx.$t('order.street')), 1),
                                        _createElementVNode("span", _hoisted_187, [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.orderResponse?.delivery?.rue || "-"), 1)
                                        ])
                                    ]),
                                    _createElementVNode("li", _hoisted_188, [
                                        _createElementVNode("span", _hoisted_189, _toDisplayString(_ctx.$t('order.number')), 1),
                                        _createElementVNode("span", _hoisted_190, [
                                            _createElementVNode("strong", null, _toDisplayString(_ctx.orderResponse?.delivery?.numberRue || "-"), 1)
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ])),
        _createElementVNode("div", _hoisted_191, [
            _createElementVNode("div", _hoisted_192, [
                _createElementVNode("div", _hoisted_193, [
                    _cache[22] || (_cache[22] = _createElementVNode("div", { class: "modal-header" }, [
                        _createElementVNode("h1", { class: "modal-title fs-5" }, "Liste des ingredients"),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        })
                    ], -1)),
                    _createElementVNode("div", _hoisted_194, [
                        _createElementVNode("div", _hoisted_195, [
                            _createElementVNode("table", _hoisted_196, [
                                _createElementVNode("thead", _hoisted_197, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", _hoisted_198, _toDisplayString(_ctx.$t('order.ingredientName')), 1),
                                        _createElementVNode("th", _hoisted_199, _toDisplayString(_ctx.$t('order.type')), 1),
                                        _createElementVNode("th", _hoisted_200, _toDisplayString(_ctx.$t('order.quantity')), 1),
                                        _createElementVNode("th", _hoisted_201, _toDisplayString(_ctx.$t('order.price')), 1)
                                    ])
                                ]),
                                (_ctx.orderItemSelected &&
                                    (_ctx.orderItemSelected.ingredients?.length > 0 ||
                                        _ctx.orderItemSelected.ingredient?.length > 0))
                                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_202, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderItemSelected.ingredients ||
                                            _ctx.orderItemSelected.ingredient, (ingredient) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: ingredient.name
                                            }, [
                                                _createElementVNode("th", _hoisted_203, [
                                                    _createVNode(_component_router_link, {
                                                        to: "/product-details",
                                                        class: "text-decoration-none text-black-emphasis"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(ingredient.name) + " - " + _toDisplayString(ingredient.size), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1024)
                                                ]),
                                                _createElementVNode("td", _hoisted_204, [
                                                    (ingredient.isDefault)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_205, _toDisplayString(_ctx.$t('order.free')), 1))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_206, _toDisplayString(_ctx.$t('order.paid')), 1))
                                                ]),
                                                _createElementVNode("td", _hoisted_207, [
                                                    _createElementVNode("div", _hoisted_208, _toDisplayString(ingredient.quantite), 1)
                                                ]),
                                                _createElementVNode("td", _hoisted_209, _toDisplayString(ingredient.extra_cost_price) + " CHF ", 1)
                                            ]));
                                        }), 128))
                                    ]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_210, [
            _createElementVNode("div", _hoisted_211, [
                _createElementVNode("div", _hoisted_212, [
                    _createElementVNode("div", _hoisted_213, [
                        _createElementVNode("h1", _hoisted_214, _toDisplayString(_ctx.$t('order.supplements')), 1),
                        _cache[23] || (_cache[23] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_215, [
                        _createElementVNode("div", _hoisted_216, [
                            _createElementVNode("table", _hoisted_217, [
                                _createElementVNode("thead", _hoisted_218, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", _hoisted_219, _toDisplayString(_ctx.$t('order.supplementName')), 1),
                                        _createElementVNode("th", _hoisted_220, _toDisplayString(_ctx.$t('order.quantity')), 1),
                                        _createElementVNode("th", _hoisted_221, _toDisplayString(_ctx.$t('order.price')), 1),
                                        _createElementVNode("th", _hoisted_222, _toDisplayString(_ctx.$t('order.total')), 1)
                                    ])
                                ]),
                                (_ctx.orderSupplementSelected &&
                                    _ctx.orderSupplementSelected?.supplement?.length > 0)
                                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_223, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderSupplementSelected.supplement, (supplement) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: supplement.id || supplement.name
                                            }, [
                                                _createElementVNode("td", _hoisted_224, _toDisplayString(supplement.name), 1),
                                                _createElementVNode("td", null, _toDisplayString(supplement.quantity || 1), 1),
                                                _createElementVNode("td", null, _toDisplayString((Number(supplement.extra_cost_price) || 0).toFixed(2)) + " CHF ", 1),
                                                _createElementVNode("td", _hoisted_225, _toDisplayString(((Number(supplement.extra_cost_price) || 0) *
                                                    (Number(supplement.quantity) || 1)).toFixed(2)) + " CHF ", 1)
                                            ]));
                                        }), 128))
                                    ]))
                                    : (_openBlock(), _createElementBlock("tbody", _hoisted_226, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("td", _hoisted_227, _toDisplayString(_ctx.$t('order.noSupplements')), 1)
                                        ])
                                    ]))
                            ])
                        ])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_228, [
            _createElementVNode("div", _hoisted_229, [
                (_ctx.orderResponse)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_230, [
                        _createElementVNode("div", _hoisted_231, [
                            _createElementVNode("h1", _hoisted_232, " Facture de la commande #" + _toDisplayString(_ctx.getShortUuid(_ctx.orderResponse.id)), 1),
                            _cache[24] || (_cache[24] = _createElementVNode("button", {
                                type: "button",
                                class: "btn-close",
                                "data-bs-dismiss": "modal",
                                "aria-label": "Close"
                            }, null, -1))
                        ]),
                        _createElementVNode("div", _hoisted_233, [
                            (_ctx.pdfUrl)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_234, [
                                    _createElementVNode("iframe", {
                                        src: _ctx.pdfUrl,
                                        width: "100%",
                                        height: "600px",
                                        style: { "border": "none" },
                                        title: "Facture PDF"
                                    }, null, 8, _hoisted_235)
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_236, " Erreur de chargement du PDF, Veuillez régénérer la facture "))
                        ]),
                        _createElementVNode("div", _hoisted_237, [
                            (_ctx.pdfUrl)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => (_ctx.printPDFFromUrl && _ctx.printPDFFromUrl(...args))),
                                    type: "button",
                                    class: "btn btn-primary"
                                }, " Imprimer maintenant "))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.regeneratePdf())),
                                    type: "button",
                                    class: "btn btn-primary"
                                }, " Régénérer la facture "))
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ])
        ])
    ], 64));
}
